import React from 'react'

import CustomerTable from '../../../components/tables/CustomerTable'
import Footer from '../layout/Footer'
import Header from '../layout/Header'

const Customer = () => {
  return (
    <>
    
    <Header />
    
    <CustomerTable />

    <Footer />

    </>
    
  )
}

export default Customer